export default __webpack_public_path__ + "static/media/Building.a84a7d47.svg";